import { App_text } from '@/settings/AppText';
import { Routes } from '@/settings/routes';
import Link from 'next/link';
import React from 'react';
import { FaAngleRight } from 'react-icons/fa6';

export default function BreadcrumbSingle({ style = 'default', currentSlug = '', parentTesxt = '', secoundParentTesxt = '', secoundParentUrl = '#', parentUrl = '#' }) {
    return (
        <ol className={`flex items-center  ${style === 'default' ? 'py-4' : ''} whitespace-nowrap`} aria-label="Breadcrumb">
            <li className="inline-flex items-center">
                <Link
                    prefetch={false}
                    href={Routes.HOME}
                    className={`flex items-center text-sm ${
                        style === 'default' ? 'text-gray-500' : 'text-white'
                    } hover:text-main-color focus:outline-none focus:text-main-color dark:focus:text-main-color`}
                >
                    {App_text.breadcrumb.home}
                </Link>
                <FaAngleRight className={`flex-shrink-0 mx-2 overflow-visible ${style === 'default' ? 'text-gray-400' : 'text-white'} size-4 dark:text-neutral-600`} />
            </li>
            {parentUrl !== '#' && (
                <li className="inline-flex items-center">
                    <Link
                        prefetch={false}
                        href={parentUrl}
                        className={`flex items-center text-sm ${
                            style === 'default' ? 'text-gray-500' : 'text-white'
                        } hover:text-main-color focus:outline-none focus:text-main-color dark:focus:text-main-color`}
                    >
                        {parentTesxt}
                        <FaAngleRight className={`flex-shrink-0 mx-2 overflow-visible ${style === 'default' ? 'text-gray-400' : 'text-white'} size-4 dark:text-neutral-600`} />
                    </Link>
                </li>
            )}
            {secoundParentUrl !== '#' && (
                <li className="inline-flex items-center">
                    <Link
                        prefetch={false}
                        href={secoundParentUrl}
                        className={`flex items-center text-sm ${
                            style === 'default' ? 'text-gray-500' : 'text-white'
                        } hover:text-main-color focus:outline-none focus:text-main-color dark:focus:text-main-color`}
                    >
                        {secoundParentTesxt}
                        <FaAngleRight className={`flex-shrink-0 mx-2 overflow-visible ${style === 'default' ? 'text-gray-400' : 'text-white'} size-4 dark:text-neutral-600`} />
                    </Link>
                </li>
            )}
            <li className={`inline-flex items-center text-sm font-semibold ${style === 'default' ? 'text-gray-800' : 'text-white'} truncate dark:text-gray-200`} aria-current="page">
                {currentSlug}
            </li>
        </ol>
    );
}
